(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hx-industrial-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hx-hero-carousel]').forEach((hero) => {
    const slides = Array.from(hero.querySelectorAll('.hx-hero-slide'));
    const buttons = Array.from(hero.querySelectorAll('[data-hx-hero-slide]'));
    const video = hero.querySelector('.hx-hero-video');
    const isMobileHero = window.matchMedia('(max-width: 749px)').matches;
    if (video) {
      video.playsInline = true;
      if (isMobileHero) {
        video.autoplay = true;
        video.muted = true;
        video.removeAttribute('controls');
        video.setAttribute('muted', '');
        video.setAttribute('webkit-playsinline', '');
      } else {
        video.autoplay = true;
      }
    }
    const fallbackToImage = () => {
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === 1));
      buttons.forEach((button, buttonIndex) => button.classList.toggle('is-active', buttonIndex === 1));
      if (video) video.pause();
    };
    const activate = (index) => {
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      buttons.forEach((button, buttonIndex) => button.classList.toggle('is-active', buttonIndex === index));
      if (index === 0 && video) {
        if (!video.src) {
          video.src = video.dataset.src;
          video.load();
        }
        video.play().catch(fallbackToImage);
      } else if (video) {
        video.pause();
      }
    };

    if (video) {
      video.addEventListener('error', fallbackToImage, { once: true });
      if (!isMobileHero && video.classList.contains('is-active')) {
        video.play().catch(fallbackToImage);
      }
    }

    buttons.forEach((button) => button.addEventListener('click', () => {
      activate(Number(button.dataset.hxHeroSlide));
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ye3-engineering-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hx-ye3-guide').forEach((section) => {
    const variantData = section.querySelector('[data-hx-ye3-variants]');
    const selectedOutput = section.querySelector('[data-hx-ye3-selected]');
    if (!variantData || !selectedOutput) return;
    let variants = [];
    try { variants = JSON.parse(variantData.textContent); } catch (error) { return; }
    document.addEventListener('change', () => {
      window.requestAnimationFrame(() => {
        const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (!idInput) return;
        const selected = variants.find((variant) => String(variant.id) === String(idInput.value));
        if (selected) selectedOutput.textContent = selected.title || selected.name;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
